<template>
  <div class="contact_box">
    <UiAnim class="animation a-tr" type="rl-100" tag="h2">Наши контакты</UiAnim>

    <UiAnim tag="p" type="rl-100" :delay="1" class="tdn" v-if="contacts?.phone || contacts?.email">
      <a v-if="contacts.phone" @click="useMetrika('phone')" :href="formatTel(contacts.phone)">{{
        formatPhone(contacts.phone)
      }}</a>
      <br v-if="contacts.phone && contacts.email" />
      <a v-if="contacts.email" @click="useMetrika('email')" :href="`mailto:${contacts.email}`">{{
        contacts.email
      }}</a>
    </UiAnim>

    <template v-if="contacts?.address">
      <UiAnim tag="h3" type="rl-100" :delay="2">Адрес</UiAnim>
      <UiAnim tag="p" type="rl-100" :delay="3">
        {{ contacts.address }}
        <template v-if="contacts?.route_link">
          <br />
          <a :href="contacts.route_link" target="_blanck">Построить маршрут</a>
        </template>
      </UiAnim>
      <UiAnim tag="p" type="rl-100" :delay="4" v-if="contacts?.work_time">{{ contacts.work_time }}</UiAnim>
    </template>

    <UiAnim class="social_links" type="rl-100" :delay="5">
      <a
        v-if="social?.instagram"
        :href="social.instagram"
        class="_soc_link"
        title="Наш Instagram"
        target="_blanck"
        @click="useMetrika('instagram')"
        ><img alt="" src="/static/image/icon/instagram.png" />
      </a>

      <a
        v-if="social?.youtube"
        :href="social.youtube"
        class="_soc_link"
        title="Наш YouTube канал"
        target="_blanck"
        @click="useMetrika('youtube')"
        ><img alt="" src="/static/image/icon/youtube.png" />
      </a>

      <a
        v-if="social?.drive2"
        :href="social.drive2"
        class="_soc_link"
        title="Блог на Drive2"
        target="_blanck"
        @click="useMetrika('drive2')"
        ><img alt="" src="/static/image/icon/d2.png" />
      </a>

      <a
        v-if="social?.ya_zen"
        :href="social.ya_zen"
        class="_soc_link"
        title="Блог на Яндекс Дзен"
        target="_blanck"
        @click="useMetrika('zen')"
      >
        <svg viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fill="#fff"
            d="M16.7 16.7c-2.2 2.27-2.36 5.1-2.55 11.3 5.78 0 9.77-.02 11.83-2.02 2-2.06 2.02-6.24 2.02-11.83-6.2.2-9.03.35-11.3 2.55M0 14.15c0 5.59.02 9.77 2.02 11.83 2.06 2 6.05 2.02 11.83 2.02-.2-6.2-.35-9.03-2.55-11.3-2.27-2.2-5.1-2.36-11.3-2.55M13.85 0C8.08 0 4.08.02 2.02 2.02.02 4.08 0 8.26 0 13.85c6.2-.2 9.03-.35 11.3-2.55 2.2-2.27 2.36-5.1 2.55-11.3m2.85 11.3C14.5 9.03 14.34 6.2 14.15 0c5.78 0 9.77.02 11.83 2.02 2 2.06 2.02 6.24 2.02 11.83-6.2-.2-9.03-.35-11.3-2.55"
          ></path>
        </svg>
      </a>

      <a
        v-if="social?.telegram"
        :href="`${social.telegram}`"
        class="telegram"
        title="Связаться через Telegram"
        target="_blank"
        @click="useMetrika('telegram')"
        ><img alt="" src="/static/image/icon/telegram.png" />
      </a>

      <a
        v-if="social?.whatsapp"
        :href="`https://wa.me/${social.whatsapp}`"
        class="whatsapp"
        title="Связаться через Whatsapp"
        target="_blank"
        @click="useMetrika('whatsapp')"
        ><img alt="" src="/static/image/icon/whatsapp.png" />
      </a>

      <span class="clr"></span>
    </UiAnim>
  </div>
</template>

<script setup>
import { formatPhone, formatTel } from "~/helpers/format";
import { inject } from "vue";
const contacts = inject("contacts");
const social = inject("social");
</script>
